module.exports = __webpack_public_path__ + "img/20_112.f46c583b.png";